import React, { Component } from "react";
import { Modal, Select, Input, message, Spin } from "antd";
import $ from "../../../common/AjaxRequest";
import API_URL from "../../../common/url";

const { Option } = Select;

class DepartmentGradeConfig extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        competingCompanyList: [],
        competingCompanySearchValue: '',
        allGradeCategoryOptions: [],
        gradeOptions: [],
    };

    show = (record) => {
        this.setState({
            params: {
                hospitalDepartmentId: record.hospitalDepartmentId,
                hasOtherSmo: record.hasOtherSmo != null ? String(record.hasOtherSmo) : undefined,
                competingCompanyIds: record.otherSmoCompanyIds ? record.otherSmoCompanyIds.split(',').filter(Boolean).map(Number) : [],
                currentMonthGradeCategory: record.currentMonthGradeCategory || undefined,
                currentMonthGrade: record.currentMonthGrade || undefined,
                isBlacklist: record.isBlacklist != null ? String(record.isBlacklist) : undefined,
            },
            visible: true,
        }, () => {
            this.loadCompetingCompanyList();
            this.loadGradeOptions();
            this.loadGradeCategoryOptions();
        });
    };

    hide = () => {
        this.setState({
            visible: false,
            competingCompanyList: [],
            competingCompanySearchValue: '',
            allGradeCategoryOptions: [],
            gradeOptions: [],
        });
    };

    loadCompetingCompanyList = (keyword) => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.competeCompany.queryCompany,
            data: { companyName: keyword || '' },
            dataType: 'json',
            doneResult: res => {
                const list = res.competingCompanyList || [];
                this.setState({ competingCompanyList: list });
            }
        });
    }

    handleCompetingCompanySearch = (value) => {
        this.setState({ competingCompanySearchValue: value });
        if (value) {
            this.loadCompetingCompanyList(value);
        } else {
            this.loadCompetingCompanyList();
        }
    }

    addCompetingCompany = (companyId) => {
        if (!companyId) return;
        const { params, competingCompanyList } = this.state;
        const ids = params.competingCompanyIds || [];
        if (ids.includes(companyId)) return;
        ids.push(companyId);
        params.competingCompanyIds = ids;
        this.setState({ params, competingCompanySearchValue: '' });
    }

    removeCompetingCompany = (companyId) => {
        const { params } = this.state;
        const ids = params.competingCompanyIds || [];
        const idx = ids.indexOf(companyId);
        if (idx > -1) ids.splice(idx, 1);
        params.competingCompanyIds = ids;
        this.setState({ params });
    }

    getCompetingCompanyName = (companyId) => {
        const { competingCompanyList } = this.state;
        const item = competingCompanyList.find(i => i.competingCompanyId === companyId);
        return item ? item.companyName : '';
    }

    loadGradeOptions = () => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.hospital.queryHospitalConfigureList,
            data: { type: 'DEPT_GRADE' },
            dataType: 'json',
            doneResult: res => {
                const list = res.list || [];
                this.setState({ gradeOptions: list });
            }
        });
    }

    loadGradeCategoryOptions = () => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.hospital.queryHospitalConfigureList,
            data: { type: 'DEPT_GRADE_CATEGORY' },
            dataType: 'json',
            doneResult: res => {
                const list = res.list || [];
                this.setState({ allGradeCategoryOptions: list });
            }
        });
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        if (key === 'hasOtherSmo' && value !== '1') {
            params.competingCompanyIds = [];
        } else if (key === 'currentMonthGradeCategory') {
            params.currentMonthGrade = undefined;
        }
        this.setState({ params });
    };

    submit = () => {
        const { params } = this.state;
        const { hospitalDepartmentId, hasOtherSmo, competingCompanyIds, currentMonthGradeCategory, currentMonthGrade, isBlacklist } = params;
        if (!hospitalDepartmentId) { message.warning("科室ID不能为空"); return; }

        this.setState({ loading: true });
        $.sendRequest({
            method: "POST",
            url: API_URL.hospital.saveDepartmentGradeConfig,
            data: {
                hospitalDepartmentId,
                hasOtherSmo: hasOtherSmo !== undefined ? Number(hasOtherSmo) : undefined,
                competingCompanyIds: (competingCompanyIds || []).join(','),
                currentMonthGradeCategory: currentMonthGradeCategory || undefined,
                currentMonthGrade: currentMonthGrade || undefined,
                isBlacklist: isBlacklist !== undefined ? Number(isBlacklist) : undefined,
            },
            dataType: "json",
            doneResult: (res) => {
                message.success(res.success || '配置成功');
                this.setState({ loading: false }, () => { this.hide(); this.props.loadData(); });
            },
            errorResult: () => { this.setState({ loading: false }); },
        });
    };

    getContent = () => {
        const { params, competingCompanyList, allGradeCategoryOptions, gradeOptions } = this.state;
        const { hasOtherSmo, competingCompanyIds, currentMonthGradeCategory, currentMonthGrade, isBlacklist } = params;
        const addedIds = competingCompanyIds || [];
        const competingCompanyOptions = (competingCompanyList || [])
            .filter(i => !addedIds.includes(i.competingCompanyId))
            .map(i => (
                <Option key={i.competingCompanyId} value={i.competingCompanyId}>{i.companyName}</Option>
            ));
        const gradeCategoryOpts = (allGradeCategoryOptions || []).map(i => (
            <Option key={i.hospitalConfigureId} value={i.hospitalConfigureId}>{i.typeValue}</Option>
        ));
        const gradeOpts = (gradeOptions || [])
            .filter(i => i.parentId === currentMonthGradeCategory)
            .map(i => (
                <Option key={i.hospitalConfigureId} value={i.hospitalConfigureId}>{i.typeValue}</Option>
            ));
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%", whiteSpace: "normal", lineHeight: "20px" }}>机构或科室是否有指定津石以外SMO:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Select allowClear={true} style={{ width: 260 }} value={hasOtherSmo !== undefined ? hasOtherSmo : undefined}
                            onChange={(value) => this.handleSelectChange(value, 'hasOtherSmo')} placeholder="请选择">
                            <Option value="1">是</Option>
                            <Option value="0">否</Option>
                        </Select>
                    </div>
                </li>
                {hasOtherSmo === '1' && (
                    <li className="modal-item">
                        <div className="item-left" style={{ width: "35%" }}>其他SMO公司:</div>
                        <div className="item-right" style={{ width: "65%" }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Select showSearch={true} filterOption={false}
                                    onSearch={this.handleCompetingCompanySearch}
                                    style={{ width: 220 }} placeholder="输入检索"
                                    value={undefined}
                                    onChange={(value) => this.addCompetingCompany(value)}
                                    notFoundContent="未找到匹配项">
                                    {competingCompanyOptions}
                                </Select>
                                <span style={{ marginLeft: 4, fontSize: 12, color: '#999' }}>选择后自动添加</span>
                            </div>
                            {competingCompanyIds && competingCompanyIds.length > 0 && (
                                <div style={{ marginTop: 4 }}>
                                    {competingCompanyIds.map(id => (
                                        <div key={id} style={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                                            <span style={{ marginRight: 4 }}>{this.getCompetingCompanyName(id)}</span>
                                            <span style={{ cursor: 'pointer', color: '#ff4d4f', fontWeight: 'bold', userSelect: 'none' }}
                                                onClick={() => this.removeCompetingCompany(id)}>-</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </li>
                )}
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>本月科室档位分类:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Select allowClear={true} style={{ width: 260 }} value={currentMonthGradeCategory}
                            onChange={(value) => this.handleSelectChange(value, 'currentMonthGradeCategory')} placeholder="请选择">
                            {gradeCategoryOpts}
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>本月科室档位:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Select allowClear={true} style={{ width: 260 }} value={currentMonthGrade}
                            disabled={!currentMonthGradeCategory}
                            placeholder={currentMonthGradeCategory ? "请选择" : "请先选择本月科室档位分类"}
                            onChange={(value) => this.handleSelectChange(value, 'currentMonthGrade')}>
                            {gradeOpts}
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "35%" }}>是否是黑名单:</div>
                    <div className="item-right" style={{ width: "65%" }}>
                        <Select allowClear={true} style={{ width: 260 }} value={isBlacklist !== undefined ? isBlacklist : undefined}
                            onChange={(value) => this.handleSelectChange(value, 'isBlacklist')} placeholder="请选择">
                            <Option value="1">是</Option>
                            <Option value="0">否</Option>
                        </Select>
                    </div>
                </li>
            </ul>
        );
    };

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="科室档位配置"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="620px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: "0 20px" }}>{this.getContent()}</div>
                </Spin>
            </Modal>
        );
    }
}

export default DepartmentGradeConfig;


// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/DepartmentGradeConfig.js